import React from 'react';
import { Box, Typography } from '@mui/material';
import { MenuBook } from '@mui/icons-material';
import GradientSurface from './GradientSurface';

/**
 * BrandMark
 * BookMyLibrary logo mark — icon + wordmark.
 * Replaces the duplicated "BML" gradient text across multiple pages.
 *
 * @param {32|40|48} size - icon size in px
 * @param {'full'|'compact'} variant - 'full' includes wordmark, 'compact' is icon-only
 */
function BrandMark({ size = 40, variant = 'full' }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <GradientSurface
        variant="brand"
        radius={size * 0.25}
        sx={{
          width: size,
          height: size,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <MenuBook sx={{ fontSize: size * 0.55, color: '#FFFFFF' }} />
      </GradientSurface>

      {variant === 'full' && (
        <Box>
          <Typography
            variant="h6"
            fontWeight={800}
            lineHeight={1}
            sx={{ color: 'text.primary' }}
          >
            BookMyLibrary
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default BrandMark;
